import React from 'react'

const Thecore = () => {
    return (
        <div>
            <svg id="The_core" data-name="The core" xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 25.185 24.501">
                <path id="Path_3" data-name="Path 3" d="M350.592,0A12.424,12.424,0,0,0,338,12.25a12.6,12.6,0,0,0,25.185,0A12.426,12.426,0,0,0,350.592,0Zm0,21.344a9.222,9.222,0,0,1-9.346-9.094,9.351,9.351,0,0,1,18.694,0A9.224,9.224,0,0,1,350.592,21.344Z" transform="translate(-338)" fill="rgba(255,255,255,0.7)" />
                <path id="Path_4" data-name="Path 4" d="M385.88,36.12h.141A5.277,5.277,0,0,1,391.3,41.4H385.88V36.12Z" transform="translate(-376.856 -29.312)" fill="rgba(255,255,255,0.7)" />
                <path id="Path_5" data-name="Path 5" d="M385.87,67.372h5.419v5.134h-.283a5.136,5.136,0,0,1-5.136-5.136h0Z" transform="translate(-376.848 -54.673)" fill="rgba(255,255,255,0.7)" />
                <path id="Path_6" data-name="Path 6" d="M417.88,77.13h3.439a3.3,3.3,0,0,1-3.3,3.3h-.141Z" transform="translate(-402.825 -62.593)" fill="rgba(255,255,255,0.7)" />
            </svg>
        </div>
    )
}

export default Thecore
